module.exports = __webpack_public_path__ + "img/tops-offshoulder.d2500a31.png";